export enum Career {
    // Core
    Young,
    Experienced,
    Veteran
}